(() => {
  const baseUrl = window.BLOG_BASE_URL || location.pathname;

  const btn = document.getElementById('TopicFilterBtn');
  const drawer = document.getElementById('TopicFilterDrawer');
  const form = document.getElementById('TopicFilterForm');
  const clearBtn = document.getElementById('TopicClear');

  const grid = document.getElementById('blog-grid');
  const activeEl = document.getElementById('ActiveTopics');

  if (!btn || !drawer || !form || !grid) return;

  const closeEls = drawer.querySelectorAll('[data-close]');
  const radios = Array.from(form.querySelectorAll('input[type="radio"][name="topic_tag"]'));

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function currentTagFromUrl() {
    const p = location.pathname;
    const idx = p.indexOf('/tagged/');
    if (idx === -1) return '';
    return p.slice(idx + 8).split('+')[0] || '';
  }

  function buildUrl(tagHandle) {
    return tagHandle ? `${baseUrl}/tagged/${tagHandle}` : baseUrl;
  }

  function syncUI(tagHandle) {
    radios.forEach(r => (r.checked = (r.value === tagHandle)));

    if (!activeEl) return;
    activeEl.innerHTML = '';

    if (!tagHandle) return;

    const r = radios.find(x => x.value === tagHandle);
    const label = r?.dataset?.label || tagHandle;

    const chip = document.createElement('button');
    chip.type = 'button';
    chip.textContent = `${label} ×`;
    chip.addEventListener('click', () => applyTag(''));
    activeEl.appendChild(chip);
  }

  async function fetchDoc(url) {
    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  async function applyTag(tagHandle, { push = true } = {}) {
    const url = buildUrl(tagHandle);
    const doc = await fetchDoc(url);

    const newGrid = doc.getElementById('blog-grid');
    if (!newGrid) return;

    // Replace grid items
    grid.innerHTML = newGrid.innerHTML;

    // Reset next url for Load More
    grid.dataset.nextUrl = newGrid.dataset.nextUrl || '';

    // Update Load More button visibility (uses the function from your load more script if present)
    if (typeof updateLoadMoreVisibility === 'function') {
      updateLoadMoreVisibility();
    } else {
      // fallback
      const btn = document.querySelector('.load-more_btn');
      btn && (btn.style.display = grid.dataset.nextUrl ? 'flex' : 'none');
    }

    if (push) history.pushState({ url }, '', url);

    syncUI(tagHandle);
    closeDrawer();
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Events
  btn.addEventListener('click', openDrawer);
  closeEls.forEach(el => el.addEventListener('click', closeDrawer));

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const selected = radios.find(r => r.checked);
    applyTag(selected ? selected.value : '');
  });

  clearBtn?.addEventListener('click', () => {
    radios.forEach(r => (r.checked = false));
    applyTag('');
  });

  window.addEventListener('popstate', () => {
    const tag = currentTagFromUrl();
    applyTag(tag, { push: false });
  });

  // Init
  syncUI(currentTagFromUrl());
})();
